import { ApiService, EntityBuildableInterface } from '@kaiser-software/chassis-core';
import { KpiSetModel } from '../models/kpi-set.model';

export class KpiSetKpiService extends ApiService implements EntityBuildableInterface {

    public restEndpoint = 'kpi_sets/{id}/kpis';

    public entityName = 'kpi';

    public model = KpiSetModel;

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/kpis/services/kpi-set-kpi.service.ts